import parent from '@/store/interfaces/historicalGeneric'
const mystore = parent({ tipoEvento: 'contactos', namespaced: true })

export default mystore
